import { render, staticRenderFns } from "./NewClientsTable.vue?vue&type=template&id=19561fc3"
import script from "./NewClientsTable.vue?vue&type=script&lang=js"
export * from "./NewClientsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports